import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { v4 as uuidV4 } from "uuid";
import { states } from "js/placeholderData/states";
import FormInputError from "components/General/FormInputError";
import MaskedPhoneNumberInput from "components/General/Form/MaskedPhoneNumberInput";

export default function FACStepFive({ formStep, setFormStep, setFACFormData }) {
  const { t } = useTranslation();
  const {
    register: FACStepFiveRegister,
    handleSubmit: FACStepFiveHandleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      funeralHomePhoneNumber: "",
    },
  });
  const uuid = uuidV4();

  const onSubmit = (data) => {
    setFormStep(6);
    setFACFormData((currentFormData) => {
      return {
        ...currentFormData,
        ...data,
      };
    });
  };

  return (
    <>
      {formStep === 5 && (
        <>
          <div>
            <p className="text-sm">{t("AgentFACStepFive-heading")}</p>

            <form onSubmit={FACStepFiveHandleSubmit(onSubmit)}>
              <hr />
              <div className="mt-6 grid gap-4 grid-cols-1 lg:gap-6">
                <div className="grid gap-4 grid-cols-1 ">
                  <div>
                    <label htmlFor={`${uuid}-fh-name`} className="block mb-1">
                      {t("AgentFACStepFive-funeralNameLabel")}
                    </label>
                    <input
                      id={`${uuid}-fh-name`}
                      type="text"
                      placeholder={t("AgentFACStepFive-funeralNamePlaceholder")}
                      {...FACStepFiveRegister(`funeralHomeName`)}
                    />
                  </div>
                </div>

                <div className="md:w-4/5">
                  <label
                    htmlFor={`${uuid}-fh-streetAddress`}
                    className="block mb-1"
                  >
                    {t("AgentFACStepFive-funeralHomeStreetAddressLabel")}
                  </label>
                  <input
                    id={`${uuid}-fh-streetAddress`}
                    type="text"
                    placeholder={t(
                      "AgentFACStepFive-funeralHomeStreetAddressPlaceholder"
                    )}
                    {...FACStepFiveRegister(`funeralHomeStreetAddress`)}
                  />
                </div>

                <div className="md:w-4/5">
                  <label
                    htmlFor={`${uuid}-fh-streetAddress2`}
                    className="block mb-1"
                  >
                    {t("AgentFACStepFive-funeralHomeStreetAddress2Label")}
                  </label>
                  <input
                    id={`${uuid}-fh-streetAddress2`}
                    type="text"
                    placeholder={t(
                      "AgentFACStepFive-funeralHomeStreetAddress2Placeholder"
                    )}
                    {...FACStepFiveRegister(`funeralHomeStreetAddress2`)}
                  />
                </div>

                <div className="grid gap-4 grid-cols-1 md:gap-y-0 md:gap-x-4 md:grid-cols-[1fr,1fr,1fr]">
                  <div>
                    <label htmlFor={`${uuid}-fh-city`} className="block mb-1">
                      {t("AgentFACStepFive-funeralHomeCityLabel")}
                    </label>
                    <input
                      id={`${uuid}-fh-city`}
                      type="text"
                      placeholder={t(
                        "AgentFACStepFive-funeralHomeCityPlaceholder"
                      )}
                      {...FACStepFiveRegister("funeralHomeCity")}
                    />
                  </div>

                  <div>
                    <label htmlFor={`${uuid}-fh-state`} className="block mb-1">
                      {t("AgentFACStepFive-funeralHomeStateLabel")}
                    </label>
                    <select
                      id={`${uuid}-fh-state`}
                      {...FACStepFiveRegister("funeralHomeState")}
                    >
                      <option value="">
                        {t("AgentFACStepFive-funeralHomeStateOption")}
                      </option>
                      {states.map((state, idx) => (
                        <option
                          value={state.abbreviation}
                          key={`state - ${state.name} - ${idx}`}
                        >
                          {state.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div>
                    <label htmlFor={`${uuid}-fh-zip`} className="block mb-1">
                      {t("AgentFACStepFive-funeralHomeZipLabel")}
                    </label>
                    <input
                      id={`${uuid}-fh-zip`}
                      type="text"
                      placeholder="Zipcode"
                      {...FACStepFiveRegister("funeralHomeZip", {
                        pattern: {
                          value: /^\d{5}$/,
                          message: t(
                            "AgentFACStepFive-funeralHomeZipPatternMessage"
                          ),
                        },
                        maxLength: {
                          value: 5,
                          message: t(
                            "AgentFACStepFive-funeralHomeZipMaxLengthMessage"
                          ),
                        },
                      })}
                    />
                    <FormInputError
                      errorMessage={errors.funeralHomeZip?.message}
                    />
                  </div>
                </div>

                <div className="grid gap-4 grid-cols-1 md:gap-y-0 md:gap-x-4 md:grid-cols-[1fr,1fr,1fr]">
                  <div>
                    <label id={`${uuid}-phone-number`} className="block mb-1">
                      {t("AgentFACStepFive-funeralHomePhoneNumberLabel")}
                    </label>
                    <MaskedPhoneNumberInput
                      name="funeralHomePhoneNumber"
                      describedby={`${uuid}-phone-number`}
                      register={FACStepFiveRegister}
                      setValue={setValue}
                      required={false}
                    />
                    <FormInputError
                      errorMessage={errors.funeralHomePhoneNumber?.message}
                    />
                  </div>
                </div>
              </div>

              <div className="flex justify-end">
                <button
                  className="ui-btn-secondary ui-btn-min-w mt-4"
                  type="button"
                  onClick={() => setFormStep((current) => current - 1)}
                >
                  {t("AgentFACStepFive-previousButtonLabel")}
                </button>

                <button className="ui-btn-primary ui-btn-min-w mt-4">
                  {t("AgentFACStepFive-continueButtonLabel")}
                </button>
              </div>
            </form>
          </div>
        </>
      )}
    </>
  );
}
